import Joi from '@hapi/joi';
import { CompensationSentenceParams } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<CompensationSentenceParams>>({});

export default function (value: Partial<CompensationSentenceParams>) {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
}
